export const wrapperStyles = {
  padding: '24px',
  height: '100%',
  overflow: 'auto',
};

export const formWrapperStyles = {
  '& .form-generator': {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '16px',
  },
};
